import { BaseModel } from "./BaseModel";

export class Integration extends BaseModel {
  schema = "/integration";
  constructor(params) {
    return super(params, "/integration");
  }
}
